import { configureStore } from '@reduxjs/toolkit';
import shopReducer from '@features/shop/shopSlice';
import cartReducer from '@features/cart/cartSlice';

export default function configureAppStore({ routes, shop, cart, localization, cartAddOnProducts }) {
	const preloadedState = {
		shop: {
			...shop,
			routes,
		},
		cart: {
			...cart,
			localization,
			cartAddOnProducts,
			isLoading: false,
		},
	};

	return configureStore({
		preloadedState,
		reducer: {
			shop: shopReducer,
			cart: cartReducer,
		},
		devTools: process.env.NODE_ENV !== 'production',
	});
}
